import { useEffect } from 'react'
import Modal from '../../_ui/modal'
import { useReviewOrderStore } from '../store/review-order-store'
import AddReviewOrderForm from './add-review-order-form'

export default function AddReviewOrderModal() {
  const open = useReviewOrderStore(s => s.open)
  const closeReview = useReviewOrderStore(s => s.closeReview)
  const order = useReviewOrderStore(s => s.order)

  useEffect(() => {
    if (!open) return

    const handlePopState = () => {
      closeReview()
    }

    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [open, closeReview])

  if (!open || !order) return null

  return (
    <Modal
      fitContent
      open={open}
      onClose={closeReview}
      disableOutsideClick
      header={{ text: 'Bagaimana Pengalaman Kamu?' }}
      render={() => <AddReviewOrderForm />}
    />
  )
}
